const ABProcessTaskUserExternalCore = require("../../../core/process/tasks/ABProcessTaskUserExternalCore");
module.exports = class ABProcessTaskUserForm extends (
   ABProcessTaskUserExternalCore
) {};
